// extracted by mini-css-extract-plugin
export default {"icon":"PinLegendSelectField_icon__6cn+Y"};